import React from "react";
import styles from "./Footer.module.css";
import Line from "../../Assets/Vector1.png";
import QR from "../../Assets/QR.png";
import Line1 from "../../Assets/Vector2.png";
import APK from "../../Assets/Apk.png";
import { Link } from "react-router-dom";
import Copyrights from "./Copyrights";
import fb from '../../Assets/f.png';
import insta from '../../Assets/i.png';
import yt from '../../Assets/y.png';
import twiter from '../../Assets/t.png'

const Footer = () => {
   const APK_DOWNLOAD_URL = process.env.REACT_APP_APK_DOWNLOAD_URL;
  // const APK_DOWNLOAD_URL =
    // "https://maquickscannerappwebsite.blob.core.windows.net/maquickscannerwebpage-container/Dear-Lottery.apk?sp=r&st=2025-08-13T03:57:06Z&se=2030-07-06T12:12:06Z&spr=https&sv=2024-11-04&sr=b&sig=zgl%2Fy6RY7mGRGkt2T0iVE2cMQ7qX3RrMVJR1suVd8F0%3D";

  return (
    <footer className={styles.footer} id="contact">
      <div className={styles.container}>
        {/* Left column */}
        <div className={styles.footerLeft}>
          <h2>SS Media App</h2>
          <img src={Line} alt="Line" />
          <p>Because your time matters, and so does staying informed.</p>
          <br />
       
        </div>

        {/* Right column */}
        {/* <div className={styles.footerRight}>
          <img src={QR} alt="QR Code" /> 
            <h3>Scan to Download</h3> 
        </div> */}
        {/* <button className={styles.downloadBtn}>
          <img src={APK} alt="APK Icon" className={styles.apkIcon} />
          <a
            href={APK_DOWNLOAD_URL}
            target="_blank"
            rel="noopener noreferrer"
            download
            className={styles?.anchorIcon}
          >
            Download APK
          </a>
        </button> */}
       
      

      </div>
       <div className={styles.footerRight}>
             <div className={styles.cen}>
              <h3>Follow us</h3>
              <div style={{display:'flex',flexDirection:'row',gap:'5px',width:'16px',height:'12px'}}>
                <img src={fb}/>
                 <img src={insta}/>
                  <img src={yt}/>
                   <img src={twiter}/>
              </div>
          </div>
          <div className={styles.cen}>
              <h3>Contact</h3>
            <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center" }}>
  <a href="mailto:developercharlestech@gmail.com" style={{ color: "#4b8abdff", textDecoration: "underline" }}>
    developercharlestech@gmail.com
  </a>
</div>

          </div>
        </div>
      <div className={styles.container1}>
        <img src={Line1} style={{ width: "80%", height: "2px" }} />
        <h5 className={styles.container2}>
          {" "}
          Copyright 2025 @ All Rights Reserved{" "}
        </h5>
        <h5 className={styles.container3}>
         <Link to="/privacy-Policy">Privacy Policy</Link>
        <span className={styles.separator}> |</span>
        <Link to="/termsandconditions">Terms & Conditions</Link>
        <span className={styles.separator}>|</span>
        <Link to="/eula">EULA</Link>
      </h5>
      </div>
    </footer>
  );
};

export default Footer;
